import { brand, nav, products } from "../data/siteContent";

export default function Footer() {
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer
      data-testid="site-footer"
      className="bg-brand-charcoal text-white pt-20 pb-10"
    >
      <div className="container mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-14">
          <div className="md:col-span-4">
            <img
              src={brand.logo}
              alt="Alumak Doors & Windows"
              className="h-14 w-auto object-contain bg-white p-2 mb-6 inline-block"
            />
            <p className="text-sm text-white/70 leading-relaxed max-w-sm">
              Η Alumak Doors & Windows σχεδιάζει και τοποθετεί ποιοτικές λύσεις
              αλουμινίου για κατοικίες, επαγγελματικούς χώρους και ξενοδοχειακές
              μονάδες.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[10px] tracking-[0.35em] uppercase text-brand-red mb-5 font-semibold">
              Πλοήγηση
            </h4>
            <ul className="space-y-3">
              {nav.map((n) => (
                <li key={n.id}>
                  <button
                    onClick={() => go(n.id)}
                    data-testid={`footer-nav-${n.id}`}
                    className="text-sm text-white/80 hover:text-brand-red transition-colors"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[10px] tracking-[0.35em] uppercase text-brand-red mb-5 font-semibold">
              Προϊόντα
            </h4>
            <ul className="space-y-3">
              {products.items.map((p) => (
                <li key={p.id}>
                  <button
                    onClick={() => go("products")}
                    className="text-sm text-white/80 hover:text-brand-red transition-colors text-left"
                  >
                    {p.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[10px] tracking-[0.35em] uppercase text-brand-red mb-5 font-semibold">
              Επικοινωνία
            </h4>
            <ul className="space-y-2 text-sm text-white/80">
              {brand.phones.map((p) => (
                <li key={p.number}>
                  <a
                    href={`tel:${p.number}`}
                    className="hover:text-brand-red transition-colors"
                  >
                    {p.display}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={`mailto:${brand.email}`}
                  className="hover:text-brand-red transition-colors break-all"
                >
                  {brand.email}
                </a>
              </li>
              <li>{brand.address}</li>
              <li className="text-white/60">{brand.hours}</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50 tracking-wide">
            © 2026 Alumak Doors & Windows. Με επιφύλαξη παντός δικαιώματος.
          </p>
          <p className="text-xs text-white/40 tracking-widest uppercase">
            Κουφώματα Αλουμινίου • Κατασκευές
          </p>
        </div>
      </div>
    </footer>
  );
}
